import { __extends } from "tslib";
import * as React from 'react';
import { CloseButton, DatePicker } from 'wix-style-react';
import { dateFormat } from '../CustomField/CustomField';
var DateInput = /** @class */ (function (_super) {
    __extends(DateInput, _super);
    function DateInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DateInput.prototype.renderDatePickerClearButton = function () {
        var _this = this;
        var dataHook = this.props.dataHook;
        return (React.createElement(CloseButton, { dataHook: "date-close-btn-" + dataHook, skin: "lightFilled", onClick: function (e) {
                // We need to stop propagation to stop the datepicker from opening
                e.stopPropagation();
                _this.props.onChange('');
            } }));
    };
    DateInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, dataHook = _a.dataHook, value = _a.value, key = _a.key, placeholder = _a.placeholder;
        return (React.createElement(DatePicker, { key: key, dataHook: dataHook, value: value ? value : '', placeholderText: placeholder, onChange: function (date) { return _this.props.onChange(dateFormat(date)); }, dateFormat: function (date) {
                return Intl.DateTimeFormat(_this.props.lng || 'en', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                }).format(new Date(date));
            }, showMonthDropdown: true, showYearDropdown: true, width: 180, locale: this.props.lng || 'en', inputProps: {
                suffix: value && this.renderDatePickerClearButton(),
            } }));
    };
    return DateInput;
}(React.Component));
export { DateInput };
//# sourceMappingURL=DateInput.js.map